import { customGet } from "../../api/customApi";
import entityType from "../../api/entityType";
import genericActionType from "../../api/genericActionType";
import { renewalListReportTypes } from "../../components/retention/reportParameters";
import { findCurrentAgencies } from "../report/reportActions";
import { Actions } from "./retentionConstants";

export const transformTextSummaryInput = (values, taskKey) => (state) => {
  const agency = findCurrentAgencies(state, values.AgencyKeys);
  const expiryDates = [values.ExpiryDate[0], values.ExpiryDate[1]];
  return {
    ...values,
    AgencyNameAndNumber: agency.FullName,
    FileName: `TextSummary_${agency.Number}`,
    ExpiryDate: expiryDates,
    ProducersTaskKey: taskKey,
  };
};

export const transformBcarRetentionInput = (values, taskKey) => (state) => {
  const agency = findCurrentAgencies(state, values.AgencyKeys);

  return {
    ...values,
    AgencyNameAndNumber: agency.FullName,
    FileName: `BCautorenewRetention_${agency.Number}`,
    ProducersTaskKey: taskKey,
  };
};

export const transformRetentionSummaryInput = (values, taskKey) => (state) => {
  const agency = findCurrentAgencies(state, values.AgencyKeys);

  // Format policy status
  let policyStatus = "";
  if (values.PolicyStatusActive === true) {
    policyStatus = "A";
  }
  if (values.PolicyStatusExpired === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "E";
  }
  if (values.PolicyStatusCancelled === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "C";
  }
  if (values.PolicyStatusRenewed === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "R";
  }
  if (values.PolicyStatusLost === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "L";
  }

  return {
    ...values,
    AgencyNameAndNumber: agency.FullName,
    FileName: `RetentionSummary_${agency.Number}`,
    ProducersTaskKey: taskKey,
    PolicyStatus: policyStatus,
  };
};

export const transformRenewalListInput = (values, taskKey) => (state) => {
  const agency = findCurrentAgencies(state, values.AgencyKeys);
  const reportName =
    values.ReportType === renewalListReportTypes.STATUS
      ? "RenewalStatus"
      : values.ReportType === renewalListReportTypes.MAILING_LABELS
      ? "MailingLabels"
      : `RenewalList_${values.ReportType}`;
  var VehicleTypesAsInt =
    values?.VehicleTypes?.length >= 1 ? values.VehicleTypes.map(Number) : [];

  // Format policy status
  let policyStatus = "";
  let policyStatusString = "";
  if (values.PolicyStatusActive === true) {
    policyStatus = "A";
    policyStatusString = "Active";
  }
  if (values.PolicyStatusExpired === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "E";
    policyStatusString =
      policyStatusString +
      (policyStatusString.length > 0 ? "," : "") +
      "Expired";
  }
  if (values.PolicyStatusCancelled === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "C";
    policyStatusString =
      policyStatusString +
      (policyStatusString.length > 0 ? "," : "") +
      "Cancelled";
  }
  if (values.PolicyStatusRenewed === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "R";
    policyStatusString =
      policyStatusString +
      (policyStatusString.length > 0 ? "," : "") +
      "Renewed";
  }
  if (values.PolicyStatusLost === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "L";
    policyStatusString =
      policyStatusString + (policyStatusString.length > 0 ? "," : "") + "Lost";
  }

  return {
    ...values,
    AgencyNameAndNumber: agency.FullName,
    FileName: `${reportName}_${agency.Number}`,
    ProducersTaskKey: taskKey,
    VehicleTypes: VehicleTypesAsInt,
    VehicleYearFrom: values.VehicleYearFrom ?? 0,
    VehicleYearTo: values.VehicleYearTo ?? 0,
    PolicyStatus: policyStatus.length > 0 ? policyStatus : "A",
    PolicyStatusString:
      policyStatusString.length > 0 ? policyStatusString : "Active",
  };
};

export const transformRenewalLettersInput =
  (values, uploadName, isPreviewMode) => (state) => {
    const agency = findCurrentAgencies(state, values.AgencyKeys);
    const originalFileName =
      state?.ui?.uploads?.find((u) => u.name === uploadName)?.fileName ?? "";

    // Format policy status
    let policyStatus = "";
    if (values.PolicyStatusActive === true) {
      policyStatus = "A";
    }
    if (values.PolicyStatusExpired === true) {
      policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "E";
    }
    if (values.PolicyStatusCancelled === true) {
      policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "C";
    }
    if (values.PolicyStatusRenewed === true) {
      policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "R";
    }
    if (values.PolicyStatusLost === true) {
      policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "L";
    }

    return {
      ...values,
      AgencyNameAndNumber: agency.FullName,
      FileName: originalFileName,
      IsPreviewMode: isPreviewMode,
      VehicleYearFrom: values.VehicleYearFrom ?? 0,
      VehicleYearTo: values.VehicleYearTo ?? 0,
      PolicyStatus: policyStatus.length > 0 ? policyStatus : "A",
    };
  };

export const listLabelFormats = () => async (dispatch) => {
  dispatch({ type: Actions.LIST_LABEL_FORMATS });

  const payload = await customGet(entityType.RETENTION, "GetLabelFormatList");

  dispatch({ type: Actions.LIST_LABEL_FORMATS_SUCCEEDED, payload });
};

export const listPolicyProducts = () => async (dispatch) => {
  dispatch({ type: Actions.LIST_POLICY_PRODUCTS });
  const payload = await customGet(entityType.PRODUCT, genericActionType.LIST);
  dispatch({ type: Actions.LIST_POLICY_PRODUCTS_SUCCEEDED, payload });
};
